import store from '@/store'

const ifAuthenticated = (to, from, next) => {
  if (store.getters['auth/loggedIn']) {
    if (store.getters['auth/tokenExpires'] < new Date() && store.getters['auth/isSessionAuth'] === false) {
      store.dispatch('auth/logOut')
      next({ name: 'Login', query: { from: to.path } })
    } else {
      if (store.getters['auth/reset'] && to.name !== "UserCurrent") {
        next({ name: 'UserCurrent', query: { reset: true, from: to.path } })
      } else {
        next()
      }
    }
  } else {
    if (to.name !== 'Login') {
      next({ name: 'Login', query: { from: to.path, ...to.query } })
    } else {
      next()
    }
  }
}

const isAdmin = (to, from, next) => {
  if (store.getters['auth/loggedIn']) {
    if (store.getters['auth/tokenExpires'] < new Date() && store.getters['auth/isSessionAuth'] === false) {
      store.dispatch('auth/logOut')
      next({ name: 'Login', query: { from: to.path } })
    } else {
      if (store.getters['auth/reset'] && to.name !== "UserCurrent") {
        next({ name: 'UserCurrent', query: { reset: true, from: to.path } })
      } else {
        if (store.getters['auth/isAdmin'])
          next()
        else
          next({ name: 'Error403', query: { p: "is_admin" }})
      }
    }
  } else {
    if (to.name !== 'Login') {
      next({ name: 'Login', query: { from: to.path } })
    } else {
      next()
    }
  }
}

export default {
  ifAuthenticated, 
  isAdmin
}
